import ShiftsCreateComponent from "../components/ShiftsCreate";
import useShiftsCreate from "../hooks/useShiftsCreate";

const ShiftsCreate = () => {
  const useShiftsCreateProps = useShiftsCreate();
  return <ShiftsCreateComponent {...useShiftsCreateProps} />;
};

export default ShiftsCreate;
